import * as interviewActions from "../interview/actions"
import * as feedbackActions from "../feedback/actions"
import * as identifierActions from "../identifiers/actions"
import * as integrationActions from "../integration/actions"
import * as searchActions from "../search/actions"
import * as simpleFlowActions from "../simpleFlow/actions"

const onResponseInner = item => {
  switch (item.type) {
    case "identity":
      return identifierActions.identityResponse
    case "sex":
      return identifierActions.sexResponse
    case "search":
      return searchActions.submitLayterms
    case "clarifier":
    case "question":
    case "cardinalQuestion":
    case "membership":
      if (item.filter) return interviewActions.filterResponse
      else if (item.inputType === "checkbox")
        return interviewActions.addCheckboxResponse
      else return interviewActions.addRadioResponse
    case "feedback":
      return feedbackActions.feedbackClick
    case "integrationPrompt":
      return feedbackActions.submitIntegrationPrompt
    case "location":
      return integrationActions.submitLocationAnswer
    case "integrationSelect":
      return integrationActions.selectIntegration
    case "integrationQues":
      return integrationActions.answerConvo
    case "intentSeekingCare":
      return searchActions.seekingCareResponse
    case "intentCareOptions":
      return searchActions.careOptionResponse
    case "specialistIntentCareOptions":
      return searchActions.specialistIntentCareOptions
    case "insuranceCapture":
      return integrationActions.insuranceCaptureResponse
    case "employerCaptureIntro":
      return integrationActions.employerIntroResponse
    case "diagnosisConcern":
      return searchActions.diagnosisInfoSubmit
    case "dxocPromptQuestion":
      return searchActions.dxocPromptResponse
    default:
      return interviewActions.addRadioResponse
  }
}

const onResponse = (item, dispatch) => response => {
  dispatch(onResponseInner(item)(response))
}

const onSubmitInner = item => {
  switch (item.type) {
    case "age":
      return identifierActions.ageSubmit
    case "name":
      return identifierActions.nameSubmit
    case "employerCaptureInput":
      return integrationActions.employerInfoSubmit
    case "specialistIntentCareOptions":
      return searchActions.specialistInfoSubmit
    case "diagnosisConcern":
      return searchActions.diagnosisInfoSubmit
    case "cardinalQuestion":
      return simpleFlowActions.cardinalQuestionSubmit
    default:
      return interviewActions.answerClick
  }
}

const onChangeInner = item => {
  switch (item.type) {
    case "name":
      return identifierActions.setName
    case "employerCaptureInput":
      return integrationActions.setEmployer
    case "specialistIntentCareOptions":
      return integrationActions.setSpecialist
    case "diagnosisConcern":
      return integrationActions.setDiagnosisConcernSearch
    default:
      return
  }
}

const onChange = (item, dispatch) => value =>
  dispatch(onChangeInner(item)(value))

const onSubmit = (item, dispatch) => () => dispatch(onSubmitInner(item)())

export { onResponse, onSubmit, onChange }



// WEBPACK FOOTER //
// ./assets/interview/handlers.js